<style scoped>

</style>
<template>
  <div>
    <div class="line text-center">
      <Button
        type="primary"
        icon="md-add"
        @click="editItem(new_item)"
      >
        添加
      </Button>
      <div class="search-input">
        <Input
          v-model="params.search"
          placeholder="请输入搜索关键字"
          @on-enter="doSearch"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        :url="query_item_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>
    <!-- 税率加载完成之后再渲染列表 -->
    <div
      v-if="tax_rate_loaded"
      class="line list-container"
    >
      <Table
        size="small"
        :columns="item_columns"
        :data="items"
        border
      />
      <Backdrop v-show="loading" />
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>

    <Modal
      v-model="edit_config.modal"
      width="400"
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_config.loading"
      @on-ok="editOk"
    >
      <div class="line">
        <Form
          ref="formInline"
          :model="edit_item"
          :label-width="40"
        >
          <FormItem label="大类">
            <Select
              v-model="edit_item.big_class"
              transfer
              placeholder="选择大类"
              @on-change="genCode"
            >
              <Option
                v-for="item in big_class_list"
                :key="item.value"
                :value="item.value"
              >
                {{ item.title }}
              </Option>
              <!-- <Option value="S">
                文具
              </Option>
              <Option value="B">
                图书
              </Option>
              <Option value="E">
                课程
              </Option>
              <Option value="P">
                周边
              </Option>
              <Option value="C">
                快消
              </Option>
              <Option value="M">
                母婴
              </Option>
              <Option value="D">
                电子物品
              </Option>
              <Option value="F">
                运费
              </Option>
              <Option value="V">
                虚拟
              </Option> -->
            </Select>
          </FormItem>
          <FormItem label="小类">
            <i-input
              v-model="edit_item.sub_class"
              type="text"
              placeholder="用一个大写字母表示"
              @on-change="genCode"
            />
          </FormItem>
          <FormItem label="小类解释">
            <i-input
              v-model="edit_item.sub_class_desc"
              type="text"
              placeholder="..."
            />
          </FormItem>
          <FormItem label="名称">
            <i-input
              v-model="edit_item.name"
              type="text"
              placeholder="货物和劳务名称"
            />
          </FormItem>
          <FormItem label="税收编码">
            <i-input
              v-model="edit_item.goods_code"
              type="text"
              placeholder="..."
              :maxlength="20"
            />
          </FormItem>
          <FormItem label="税率">
            <Select
              v-model="edit_item.tax_rate_id"
              placeholder="选择税率"
            >
              <Option
                v-for="tax_rate in tax_rates"
                :key="tax_rate.id"
                :value="tax_rate.id"
              >
                {{ getTaxRateValue(tax_rate.id) }}
              </Option>
            </Select>
            <!-- <InputNumber v-model="edit_item.tax_rate" placeholder="0.16 / 0.03 / 0.06 等"></InputNumber> -->
          </FormItem>
        </Form>
      </div>
    </Modal>
  </div>
</template>
<script route="/stock/tax_code">
  import StockUtil from './libs/util';
  import BaseItem from '../mixins/base_item';
  export default {
    /* router_info_start */
    router_info: '/stock/tax_code',
    /* router_info_end */

    mixins: [BaseItem],
    data() {
      return {
        query_item_path: Util.api.query_tax_code,
        update_item_path: Util.api.update_tax_code,
        new_item: {
          big_class: '',
          sub_class: '',
          sub_class_desc: '',
          code: '',
          name: '',
          goods_code: '',
          tax_rate_id: 0
        },
        tax_rates: [],
        tax_rates_hash: {},
        big_class_list: [
          {
            title: '图书',
            value: 'B'
          },
          {
            title: '文具',
            value: 'S'
          },
          {
            title: '课程',
            value: 'E'
          },
          {
            title: '周边',
            value: 'P'
          },
        ],
        item_columns: [
          {
            title: '大类',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const row = params.row;
              const big_class = row.big_class;
              let text = '';
              switch (big_class) {
              case 'S':
                text = '文具(S)';
                break;
              case 'B':
                text = '图书(B)';
                break;
              case 'E':
                text = '课程(E)';
                break;
              // case 'F':
              //   text = '运费(F)';
              //   break;
              // case 'V':
              //   text = '虚拟(V)';
              //   break;
              // case 'D':
              //   text = '电子物品(D)';
              //   break;
              case 'P':
                text = '周边(P)';
                break;
              // case 'C':
              //   text = '快消(C)';
              //   break;
              // case 'M':
              //   text = '母婴(M)';
              //   break;
              default:
                text = '未定义类型';
              }
              return h('div', text);
            }
          },
          {
            title: '小类',
            key: 'sub_class',
            width: 50,
            align: 'center'
          },
          {
            title: '小类解释',
            key: 'sub_class_desc',
            width: 100,
            align: 'center'
          },
          {
            title: '税码',
            key: 'code',
            width: 60,
            align: 'center'
          },
          {
            title: '名称',
            key: 'name',
            align: 'center'
          },
          {
            title: '税收编码',
            key: 'goods_code',
            width: 180,
            align: 'center'
          },
          {
            title: '税率',
            key: 'tax_rate',
            width: 60,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('div', this.getTaxRateValue(row.tax_rate_id));
            }
          },
          {
            title: '操作',
            width: 70,
            align: 'center',
            render: (h, params) => {
              return h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click:() => {
                    this.editItem(params.row);
                  }
                }
              }, '编辑');
            }
          }
        ],
      }
    },
    computed: {
      tax_rate_loaded() {
        return this.tax_rates.length > 0;
      }
    },
    created() {
      this.getTaxRates();
    },
    mounted() {
      //
    },
    methods: {
      getTaxRates() {
        StockUtil.getTaxRates().then((data) => {
          this.tax_rates = data.tax_rates;
          this.tax_rates.forEach((tax_rate) => {
            this.tax_rates_hash[tax_rate.id] = tax_rate;
          });
        }).catch((e) => {
          this.$Modal.error({title: '提示', content: e.message});
        });
      },
      getTaxRateValue(id) {
        const tax_rate = this.tax_rates_hash[id];
        if (tax_rate) {
          if (math.eval(`${tax_rate.value} == -1`)) {
            return '不征收';
          } else if (math.eval(`${tax_rate.value} == -2`)) {
            return '免税';
          } else {
            return tax_rate.value;
          }
        }
        return '未定义';
      },
      genCode() {
        this.edit_item.sub_class = this.edit_item.sub_class.toUpperCase();
        this.edit_item.code = `TX${this.edit_item.big_class}${this.edit_item.sub_class}`;
      },
      checkValid() {
        let msg = '';
        if (!this.edit_item.big_class) {
          msg += '<p>请选择[大类]</p>';
        }
        if (!this.edit_item.sub_class) {
          msg += '<p>请填写[小类]</p>';
        }
        if (!/[A-Z]/.test(this.edit_item.sub_class)) {
          msg += '<p>[小类]只能为大写字母</p>';
        }
        if (!this.edit_item.name) {
          msg += '<p>请填写[名称]</p>';
        }
        if (!this.edit_item.goods_code) {
          msg += '<p>请填写[税收编码]</p>';
        }
        if (msg) {
          this.$Modal.error({
            title: '提示',
            content: msg
          });
          return false;
        }
        return true;
      },
      rowClassName(row, index) {
        if (row.del) {
          return 'color-error';
        }
        return '';
      }
    }
  }
</script>
